export default "__VITE_ASSET__YbTh8NJ1__"